/* [EZ] Sticky-bar variant selector. Horizon's sticky add-to-cart bar only shows the variant
   TITLE as static text — no way to switch variants without scrolling back up. This injects
   branded PILL buttons into the sticky bar that drive the MAIN variant picker (so Horizon's
   native flow runs: price, image, availability, and the sticky bar all update).

   While the chosen variant loads we DISABLE the sticky Add to Cart and show a spinner (so the
   wrong item can't be added mid-switch); it clears when the variant settles (the sticky element's
   data-current-variant-id changes after Horizon's morph) — with a safety timeout.

   The sticky bar morphs its children on variant change (wiping our pills), so we re-inject via a
   MutationObserver. Scope: single-option products (the realistic multi-variant case here);
   multi-option degrades to the static title; single-variant is untouched. No core edits. */
(function () {
  var pending = null;
  var safety = null;

  // --- [EZ] OOS "Coming Soon" + EXCLUSIVE "Purchase at <brand>" for the sticky bar ---
  // (mirrors ez-pdp-buyrow.js / ez-exclusive.js for the main buy row). We relabel the sticky ATC and
  // keep it disabled/linked as appropriate; a CSS override (.ez-sticky-oos / .ez-sticky-excl in
  // ez-pdp-layout.css) defeats Horizon's unavailable-hide so the bar still appears on scroll — Horizon's
  // own IntersectionObserver drives data-stuck regardless of availability, so we don't touch that.
  var COMING_SOON = 'Coming Soon';
  function stickyAtc() { var b = stickyBar(); return b && b.querySelector('.sticky-add-to-cart__button, [ref="addToCartButton"]'); }
  function isOos() { var s = stickyEl(); return !!s && s.dataset.variantAvailable === 'false'; }
  // Exclusive-brand data (same script ez-exclusive.js reads). Non-null → this product is "Purchase at <brand>".
  function getExclusive() {
    var d = document.querySelector('script[type="application/json"][data-ez-exclusive]');
    if (!d) return null;
    try { var j = JSON.parse(d.textContent); return j && j.brand ? j : null; } catch (e) { return null; }
  }
  // The visible label is the deepest element inside .add-to-cart-text__content (same structure as the
  // main buy row). Set THAT — never insert a stray text node (that caused a double "Coming Soon").
  function labelEl(btn) { var el = btn.querySelector('.add-to-cart-text__content'); if (!el) return null; while (el.firstElementChild) el = el.firstElementChild; return el; }
  function setLabel(btn, node, txt) { if (btn.dataset.ezOosOrig == null) btn.dataset.ezOosOrig = node ? node.textContent : ''; if (node && node.textContent.trim() !== txt) node.textContent = txt; }
  // Exclusive sticky ATC opens the brand link in a new tab (a form button can't be a link) — intercept
  // the puppet add-to-cart click. Bound once per button (re-bound after Horizon morphs the bar).
  function bindExclLink(btn, link) {
    if (btn.dataset.ezExclLink === link) return;
    btn.dataset.ezExclLink = link;
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); window.open(link, '_blank', 'noopener'); }, true);
  }
  function applyOos() {   // "state": exclusive (precedence) → OOS "Coming Soon" → normal
    var s = stickyEl(); if (!s) return;
    var btn = stickyAtc(); if (!btn) return;
    var node = labelEl(btn);
    var ex = getExclusive();
    s.classList.remove('ez-sticky-oos', 'ez-sticky-excl', 'ez-sticky-excl-disabled');
    if (ex) {
      setLabel(btn, node, 'Purchase at ' + ex.brand);
      if (ex.hasLink && ex.link) {
        btn.disabled = false; btn.removeAttribute('aria-disabled');
        s.classList.add('ez-sticky-excl'); bindExclLink(btn, ex.link);
      } else {
        btn.disabled = true; btn.setAttribute('aria-disabled', 'true');
        s.classList.add('ez-sticky-excl', 'ez-sticky-excl-disabled');
      }
    } else if (isOos()) {
      setLabel(btn, node, COMING_SOON);
      btn.disabled = true; btn.setAttribute('aria-disabled', 'true');
      s.classList.add('ez-sticky-oos');
    } else {
      if (node && btn.dataset.ezOosOrig != null) { node.textContent = btn.dataset.ezOosOrig; delete btn.dataset.ezOosOrig; }
    }
  }

  function stickyEl() { return document.querySelector('sticky-add-to-cart'); }
  function stickyBar() { var s = stickyEl(); return s && s.querySelector('[ref="stickyBar"]'); }
  function mainPicker() { return document.querySelector('variant-picker'); }

  // Variant list from the main picker — only for a usable single-option product (one fieldset of
  // radios, or one dropdown), where each value maps to a variant id.
  function buildControls() {
    var picker = mainPicker();
    if (!picker) return [];
    var controls = [];
    var selects = picker.querySelectorAll('select.variant-option__select');
    var fieldsets = picker.querySelectorAll('fieldset');

    if (selects.length === 1) {
      selects[0].querySelectorAll('option[data-variant-id]').forEach(function (opt) {
        var id = opt.getAttribute('data-variant-id'); if (!id) return;
        controls.push({
          id: id, label: (opt.value || opt.textContent).trim(), available: true,
          activate: function () { var s = opt.closest('select'); s.value = opt.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
    } else if (selects.length === 0 && fieldsets.length === 1) {
      fieldsets[0].querySelectorAll('input[type="radio"][data-variant-id]').forEach(function (inp) {
        var id = inp.getAttribute('data-variant-id'); if (!id) return;
        controls.push({
          id: id, label: (inp.value || inp.getAttribute('aria-label') || '').trim(),
          available: inp.getAttribute('data-option-available') !== 'false',
          activate: function () { inp.click(); }
        });
      });
    }
    return controls;
  }

  function setLoading(on) {
    var s = stickyEl(); if (!s) return;
    s.classList.toggle('ez-sv-loading', !!on);
    if (on) {
      clearTimeout(safety);
      safety = setTimeout(function () { setLoading(false); }, 4000); // never stay stuck
    } else {
      clearTimeout(safety);
    }
  }

  function inject() {
    var bar = stickyBar();
    if (!bar || bar.querySelector('.ez-sv')) return; // none / already injected
    var slot = bar.querySelector('.sticky-add-to-cart__variant');
    if (!slot) return;
    var controls = buildControls();
    if (controls.length < 2) return; // single/multi-option → degrade, keep the static title

    var current = (stickyEl() && stickyEl().dataset.currentVariantId) || '';
    var wrap = document.createElement('div');
    wrap.className = 'ez-sv';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Choose a variant');
    controls.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ez-sv__pill' + (c.id === current ? ' is-active' : '');
      b.setAttribute('data-vid', c.id);
      b.textContent = c.label;
      if (!c.available) { b.disabled = true; b.title = 'Sold out'; }
      b.addEventListener('click', function () {
        if (b.disabled || b.classList.contains('is-active')) return;
        // optimistic active state + lock ATC while Horizon loads the variant
        wrap.querySelectorAll('.ez-sv__pill').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        setLoading(true);
        for (var i = 0; i < controls.length; i++) {
          if (controls[i].id === c.id) { controls[i].activate(); break; }
        }
      });
      wrap.appendChild(b);
    });
    var spin = document.createElement('span');
    spin.className = 'ez-sv__spin ez-spin';
    spin.setAttribute('aria-hidden', 'true');
    wrap.appendChild(spin);

    slot.innerHTML = '';
    slot.appendChild(wrap);
    slot.style.display = '';
  }

  function schedule() { clearTimeout(pending); pending = setTimeout(function () { inject(); applyOos(); }, 60); }

  function start() {
    var bar = stickyBar();
    if (!bar) return;
    inject();
    applyOos();
    // Re-inject + re-apply OOS after Horizon morphs the sticky bar on variant change (it wipes both).
    new MutationObserver(schedule).observe(bar, { childList: true, subtree: true });
    // Variant settled (component updates data-current-variant-id after its morph) → unlock ATC + re-check OOS.
    var s = stickyEl();
    if (s) {
      new MutationObserver(function () { setLoading(false); })
        .observe(s, { attributes: true, attributeFilter: ['data-current-variant-id'] });
      // Availability flips on variant change (component updates data-variant-available) → relabel.
      new MutationObserver(applyOos)
        .observe(s, { attributes: true, attributeFilter: ['data-variant-available'] });
    }
    window.addEventListener('load', function () { inject(); applyOos(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
